import React, { useState } from 'react';
import { setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
const innerData = [
	{
		title: 'Situation',
		isSelected: false
	},
	{
		title: 'Background',
		isSelected: false
	},
	{
		title: 'Assessment',
		isSelected: false
	},
	{
		title: 'Recommendation',
		isSelected: false
	}
]

const SBARUI = (props: UIProperties<SBARUIConfig>) => {
	const [selectedSectionIndex, setSelectedSectionIndex] = useState(0);
	const updateSelection = (indx: number) => {
		if(indx < 0)  {
			indx = 0;
		}

		if(indx > innerData.length - 1) {
			indx = innerData.length - 1;
		}
		setFocus('sbar-header');
		setSelectedSectionIndex(indx);
	}
	const getContent = () => {
		var content = null;
		var content508 = null;
		switch(selectedSectionIndex) {
			case 0:
				content = props.parameters.s;
				content508 = props.parameters.s508;
				break;
			case 1:
				content = props.parameters.b;
				content508 = props.parameters.b508;
				break;
			case 2:
				content = props.parameters.a;
				content508 = props.parameters.a508;
				break;
			case 3:
				content = props.parameters.r;
				content508 = props.parameters.r508;
				break;
		}
		return `
			<div style="position: absolute;top: 20px;left: 20px;width: calc(100% - 40px);height: calc(100% - 40px);overflow: auto;">
				<p tabindex=0 aria-label='${content508 ?? content}' class="title-font" style="font-weight: normal;margin: 0;color:#EDC300;">`+
					content
				+`</p>
			</div>
		`
	};
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div id="sbar-root" aria-label='s bar' tabIndex={0} style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '1360px',
				height: '900px'
			}}>
				<img style={{
					width: '100%',
					height: '90px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					width: '100%',
					height: '810px',
					position: 'absolute',
					top: '90px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<div style={{
						position: 'absolute',
						top: '20px',
						left: '10px',
						width: '400px',
						height: '50px',
					}}>
						<div style={{
							position: 'absolute',
							top: '0',
							left: '0',
							display: 'grid',
							width: '300px',
							height: '100%',
							gridTemplateColumns: 'auto auto auto auto'
						}}>
							{innerData.map((data: any, index: number) => {
								return (
									<div style={{
										position: 'relative',
										marginLeft: '10px'
									}} onClick={() => {
										setSelectedSectionIndex(index);
									}}>
										<img style={{
											width: '100%',
											height: '100%'
										}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
										<p className='title-font center-on-container' style={{
											margin: 0,
											pointerEvents: 'none'
										}}>{data.title[0]}</p>
										{selectedSectionIndex === index ? <img style={{
											position: 'absolute',
											right: '0',
											pointerEvents: 'none',
											top: '0',
											width: '20px',
											height: '40px'
										}} src="./assets/images/SBAR/button_debrief_check.png"/> : (null)}
									</div>
								);
							})}
						</div>
						<p tabIndex={0} id='sbar-header' className='title-font' style={{
							position: 'absolute',
							left: '310px',
							top: '50%',
							transform: 'translate(0, -50%)',
							margin: '0'
						}}>{innerData[selectedSectionIndex].title}</p>
					</div>
					
					<div style={{
						position: 'absolute',
						top: '80px',
						left: '20px',
						backgroundColor: 'rgb(20, 20, 20)',
						border: '3px solid rgb(86, 87, 86)',
						width: 'calc(100% - 40px)',
						height: '630px'
					}} dangerouslySetInnerHTML={{__html: getContent()}}>
					</div>

				</div>
				<div style={{
					position: 'absolute',
					top: '814px',
					left: '20px',
					width: 'calc(100% - 40px)',
					height: '71px'
				}}>
					{selectedSectionIndex > 0 ? <GeneralButtonWithText parameters= {{
						text: 'Previous',
						ariaLbl: 'Previous',
						top: '0',
						left: '0',
						width: '195px',
						srcIdle: "./assets/images/dialog/button_next_2_main.png",
						srcHighlight: "./assets/images/dialog/button_next_2_down.png",
						customImgStyle: {
							transform: 'scaleX(-1)'
						},
						onClicked: () => {updateSelection(selectedSectionIndex-1)}
					}}/> : (null)}
					
					<GeneralButtonWithText parameters= {{
						text: 'Close',
						ariaLbl: 'Close',
						id: selectedSectionIndex < innerData.length - 1 ? null : 'sbar-close-bttn',
						top: '0',
						left: '560px',
						width: '195px',
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						customImgStyle: {
							width: '100%',
							height: '64px'
						},
						customButtonStyle : {
							width: '100%',
							height: '64px'
						},
						onClicked: () => {
							const customClosed = (window as any).onSbarClosed;

							if(customClosed) {
								customClosed();
							}
							
							customClosed();
							if(props.parameters.onClosedClicked) {
								props.parameters.onClosedClicked();
							}
						}
					}}/>

					{selectedSectionIndex < innerData.length - 1 ? <GeneralButtonWithText parameters= {{
						text: 'Next',
						id: 'sbar-close-bttn',
						ariaLbl: 'Next',
						top: '0',
						left: '1122px',
						width: '195px',
						srcIdle: "./assets/images/dialog/button_next_2_main.png",
						srcHighlight: "./assets/images/dialog/button_next_2_down.png",
						onClicked: () => {updateSelection(selectedSectionIndex+1)}
					}}/> : (null)}
				</div>
				
			</div>
		</div>
	);

};

export interface SBARUIConfig extends BaseConfig{
	s: string;
	s508?: string;
	b: string;
	b508?: string;
	a: string;
	a508?: string;
	r: string;
	r508?: string;
	onClosedClicked?: () => void;
}

export default SBARUI;